import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { LastPage, AllInclusive, Add, MoreVert, Edit, Delete, Done, Block, Visibility, Gavel, FilterList, FormatListNumbered, ConfirmationNumber, HourglassEmpty, Check, Close } from '@material-ui/icons';

import { withLocalize, Translate } from "react-localize-redux";

import {
  TableRow,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Grid,
  Slide, Link
} from "@material-ui/core";

import Format from "date-fns/format";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import { TransportService, ReportingService, AdminService, FinanceService, groupBy } from "./../../utils/web_config_2";


import UserInfo from "./login_info";

import DateFnsUtils from "@date-io/date-fns";

import axios from 'axios';

import Chart from 'react-apexcharts'

import Skeleton from '@material-ui/lab/Skeleton';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { format } from "date-fns/esm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow: 1,
    [theme.breakpoints.up('sm')]: {
      marginLeft: 250,
    }
  },
  btn: {
    textTransform: "capitalize",

  },
  formTitle: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    height: 300,
    elevation: 0
  }, appBar: {
    position: 'relative',
  }, title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  }
}));


function ReportPOS() {
  const classes = useStyles1();

  // new offense dialog 

  const [open, setOpen] = useState(false);

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [reportsMessage, setReportsMessage] = useState("Loading...");
  const [reportTitle, setReportTitle] = useState("Bus Daily report");

  const [currency, setCurrency] = useState("");



  const history = useHistory();

  const [reportLoad, setReportLoad] = useState(false);


  const [reports, setReports] = useState([]);

  // pagination
  const [pages, setPages] = useState(0)
  const [perPage, setPerPage] = useState(1000000);
  const [pageN, setPageN] = useState(0);
  const [totalElements, setTotalElements] = useState(0)
  const [isFiltering, setIsFiltering] = useState(false)


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //offenses table 


  const columns = [
    {
      name: 'plate_nbr',
      label: 'Plate Number',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          var obj = reports.find((o) => o['plate_nbr'] == value);
          var currency = obj['amount'].split(" ")[1];
          return (
            <Typography color='primary'>
              <Link
                href='#'
                onClick={() => {
                  setBus(value);
                  get_daily_details(value, currency);
                }}
              >
                {value}
              </Link>
            </Typography>
          );
        },
      },
    },
    {
      name: 'luggage_tickets',
      label: 'Luggage Tickets',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'luggage_amount',
      label: 'Luggage Amount',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'passanger_tickets',
      label: 'Passenger Ticket',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'passanger_amount',
      label: 'Passenger Amount',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'total_tickets',
      label: 'Total Tickets',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'amount',
      label: 'Total Amount',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];



  const options = {
    textLabels: {
      body: {
        noMatch: reportsMessage
      },
    },
    filterType: 'checkbox',
    download: true,
    responsive: "standard",
    selectableRows: false,
    count: totalElements,
    page: pages,
    rowsPerPage: 1000000,
    rowsPerPage: perPage,
    serverSide: true,
    pagination: !reportLoad,
    elevation: 0,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <Box>
        <Chip
          className={classes.chip}
          icon={<Visibility />}
          color="primary"
          variant="outlined"
          label="View details"
          onClick={() => {
            var id = displayData[selectedRows.data[0]['index']]['data'][0];
            console.log("ticket id", id);
          }} />
      </Box>
    ),


    onChangePage: (page) => {

      setPageN(page)
      if (isFiltering) {
        filter_report(page)
      } else {
        get_bus_report(operatorData.token, page)
      }

    },
    onChangeRowsPerPage: (rowsPerPage) => {

      setPerPage(rowsPerPage)
      if (isFiltering) {
        filter_report(pageN, rowsPerPage)
      } else {
        get_bus_report(operatorData.token, pageN, rowsPerPage)
      }

    },

  };


  useEffect(() => {

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }


    setOperatorData(data);


    get_bus_report(data.token, 0);
    get_buses(data.token);


  }, []);


  // format money 

  function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };


  const getDate = () => {
    return Format(new Date(), ["yyyy-MM-dd",]);
  }



  const [amounts, setAmounts] = useState([]);
  const [labels, setLabels] = useState([]);
  const [revenue, setRevenue] = useState([]);
  const [totalsByCurrencies, setTotalsByCurrencies] = useState([]);
  // bus performance 

  const bus_performance =
  {
    options: {
      series: [],
      chart: {
        width: 380,
        type: 'pie',
      },
      dataLabels: {
        enabled: false
      },
      labels: labels,
      legend: {
        position: 'right',
        itemMargin: {
          horizontal: 0
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 280,
            height: 280
          },
          legend: {
            position: 'right'
          }
        }
      }]
    }
  }

  // bus revemue  

  const revenue_bus =
  {
    options: {
      series: [{
        name: 'Revenue',
        data: revenue
      }],
      chart: {
        height: 350,
        type: 'bar',
        tools: {
          download: false,
          selection: false,
          pan: false,
          reset: false,
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          distributed: false,
          startingShape: "flat",
          columnWidth: '5px',
          dataLabels: {
            enabled: false,
          },
        },
      },
      dataLabels: {
        enabled: false,
        formatter: function (val) {
          return val + " ";
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ["#304758"]
        }
      },

      xaxis: {
        categories: labels,
        position: 'bottom',
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        crosshairs: {
          fill: {
            type: 'gradient',
            gradient: {
              colorFrom: '#D8E3F0',
              colorTo: '#BED1E6',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            }
          }
        },
        tooltip: {
          enabled: true,
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val + " ";
          }
        }

      },

    }
  };

  // get bus 

  const [buses, setBuses] = useState([]);
  const get_buses = (token) => {
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const busInstance = axios.create(new AdminService().setHeaders(token));
    busInstance.get("/api/v1/operator-vehicle/organization/" + new UserInfo().ORG_ID + "/status/ENABLED")
      .then(res => {
        var objs = res.data.data;
        if (objs.length != 0) {
          setBuses(objs);
        } else {
          enqueueSnackbar("No Buses available!", {
            variant: 'info',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }
      })
      .catch(err => {
        enqueueSnackbar(err.message, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      });
  }

  // get pos report 

  const [totalTickets, setTotalTickets] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);




  const get_bus_report = (token, page, size = undefined) => {
    setReportLoad(true);
    axios.defaults.baseURL = new ReportingService().BASE_URL;
    const reportInstance = axios.create(new ReportingService().setHeaders(token));
    reportInstance.post(`/pos-report/bus-detail-report?page=${page}&size=${size ?? perPage}`,
      // {
      //   "bus":"",
      //   "form":getDate(),
      //   "to":getDate(),
      //   "day":  getDate(),
      //   "organization_id":new UserInfo().ORG_ID
      // }
      // {
      //   "bus": "",
      //   "form": getDate(),
      //   "organization_id": new UserInfo().ORG_ID,
      //   "route": "",
      //   "to": getDate()
      // }
      {
        "bus": "",
        "form": getDate(),
        "organization_id": new UserInfo().ORG_ID,
        "route": "",
        "to": getDate()
      }
    )
      .then(res => {
        // set number of pages 
        setPages(res.data.data.totalPages)
        // set total element
        setTotalElements(res.data.data.totalElements)
        var objs = res.data.data.content;
        var curr = "";
        console.log("=====  report =====");
        if (objs.length == 0) {
          setReportsMessage("No BUS report available today");
          setReportLoad(false);
        } else {

          var performance = [];
          var lebals = [];

          var total = objs.reduce((a, b) => {
            return a + parseInt(b.total_amount);
          }, 0);

          var tickets = objs.reduce((a, b) => {
            return a + parseInt(b.total_tickets);
          }, 0);


          const currTotals = [];

          objs.forEach((obj) => {
            if (currTotals[obj.currency]) {
              currTotals[obj.currency].total_tickets += obj.total_tickets;
              currTotals[obj.currency].total_amount += obj.total_amount;
            } else {
              currTotals[obj.currency] = {
                total_tickets: obj.total_tickets,
                total_amount: obj.total_amount,
              };
            }
          });

          setTotalsByCurrencies(currTotals);


          setTotalAmount(total);
          setTotalTickets(tickets);


          let unique_percentage = [];
          let unique_revenue = [];
          let unique_bus = [];


          // group by plate number 


          var firstPage = [];

          var groupByPlate = groupBy(objs, function (item) {
            return [item.plate_nbr, item.currency];
          });

          groupByPlate.map((o) => {
            var buses = o;
            var plate = buses[0]['plate_nbr'];
            var currency = buses[0]['currency'];
            curr = buses[0]['currency'];
            var total_amount = buses.reduce(function (sum, amount) {
              return sum + parseInt(amount.total_amount);
            }, 0);
            var total_tickets = buses.reduce(function (sum, tickets) {
              return sum + parseInt(tickets.total_tickets);
            }, 0);

            var luggage_tickets = buses.reduce(function (sum, tickets) {
              return sum + parseInt(tickets.luggage_tickets);
            }, 0);

            var passanger_tickets = buses.reduce(function (sum, tickets) {
              return sum + parseInt(tickets.passanger_tickets);
            }, 0);

            var luggage_amount = buses.reduce(function (sum, tickets) {
              return sum + parseInt(tickets.luggage_amount);
            }, 0);

            var passanger_amount = buses.reduce(function (sum, tickets) {
              return sum + parseInt(tickets.passanger_amount);
            }, 0);

            var obj = { "plate_nbr": plate, "total_tickets": total_tickets, "amount": formatMoney(total_amount, 0) + " " + currency, "luggage_tickets": luggage_tickets, "passanger_tickets": passanger_tickets, "luggage_amount": formatMoney(luggage_amount, 0) + " " + currency, "passanger_amount": formatMoney(passanger_amount, 0) + " " + currency };

            // set values for chart 

            performance.push(total_amount);
            lebals.push(plate);

            // set values for pie chart 

            unique_revenue.push(total_amount);
            unique_percentage.push(total_tickets);

            // set unique bus

            unique_bus.push(plate);


            firstPage.push(obj);

            console.log("first page ===>", firstPage)

          });

          setAmounts(unique_percentage);
          setLabels(unique_bus)
          setRevenue(unique_revenue);

          setReportTitle("Date : " + startDate.value)

          setReports(firstPage);
          setFilterDialog(false);
          setReportLoad(false);

          // group by plate , departure and route 

          var groupBySchedule = [];

          var groupByPlateDeparture = groupBy(objs, function (item) {
            return [item.plate_nbr, item.departure_time, item.route, item.currency];
          });


          groupByPlateDeparture.map((o, i) => {
            var buses = o;
            var currency = buses[0]['currency'];
            var total_amount = buses.reduce(function (sum, amount) {
              return sum + parseInt(amount.total_amount);
            }, 0);
            var total_tickets = buses.reduce(function (sum, tickets) {
              return sum + parseInt(tickets.total_tickets);
            }, 0);

            var obj = { id: i + 1, currency: currency, departure_time: buses[0]['departure_time'], plate_nbr: buses[0]['plate_nbr'], route: buses[0]['route'], total_amount: total_amount, total_tickets: total_tickets };
            groupBySchedule.push(obj);

          });


          setGroupedBySchedule(groupBySchedule);

          setCurrency(curr);

        }


      })
      .catch(err => {

        setReportLoad(false);
        if (err.message) {
          setReportsMessage(err.message);
          enqueueSnackbar(err.message,
            {
              variant: 'error'
            });
        }

        if (err.response) {
          setReportsMessage(err.response.data.message);
          enqueueSnackbar(err.response.data.message,
            {
              variant: 'error'
            });
        }
      });

  }


  // filter report 


  // filter dialog 
  const [filterDialog, setFilterDialog] = useState(false);


  // filter fines titckets

  const [startDate, setStartDate] = useState({ value: Format(new Date(), ["yyyy-MM-dd",]), error: "" });
  const [endDate, setEndDate] = useState({ value: Format(new Date(), ["yyyy-MM-dd",]), error: "" });
  const [plateNumber, setPlateNumber] = useState({ value: "", error: "" });

  const [groupedBySchedule, setGroupedBySchedule] = useState([]);


  const filter_report = (page, size = undefined) => {


    if (plateNumber.value != "") {

      // with specific bus 

      setReports([]);
      setTotalAmount(0);
      setTotalTickets(0);
      if (startDate.value == endDate.value) {

        // day specific bus 
        setReportTitle("Bus: " + plateNumber.value + " , Date: " + startDate.value);
        setReportLoad(true);
        setAmounts([]);
        setLabels([]);
        setRevenue([]);
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
        filterInstance.post(`/pos-report/bus-detail-report?page=${page}&size=${size ?? perPage}`,
          // {
          //       "bus":plateNumber.value,
          //       "day":startDate.value,
          //       "organization_id":new UserInfo().ORG_ID
          //   }

          {
            "bus": plateNumber.value,
            "form": startDate.value,
            "organization_id": new UserInfo().ORG_ID,
            "route": "",
            "to": startDate.value
          }

        )
          .then(res => {
            // set number of pages 
            setPages(res.data.data.totalPages)
            // set total element
            setTotalElements(res.data.data.totalElements)
            var objs = res.data.data.content;
            handleAll(objs);
            setReportLoad(false);

            const currTotals = [];

            objs.forEach((obj) => {
              if (currTotals[obj.currency]) {
                currTotals[obj.currency].total_tickets += obj.total_tickets;
                currTotals[obj.currency].total_amount += obj.total_amount;
              } else {
                currTotals[obj.currency] = {
                  total_tickets: obj.total_tickets,
                  total_amount: obj.total_amount,
                };
              }
            }
            );

            setTotalsByCurrencies(currTotals);
          })
          .catch(err => {

          });
      } else if (startDate.value > endDate.value || startDate.value < endDate.value) {

        // duration specific bus 

        setReportTitle("Bus: " + plateNumber.value + ", Start date: " + startDate.value + " - End date: " + endDate.value);
        setReportLoad(true);
        setAmounts([]);
        setLabels([]);
        setRevenue([]);
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
        filterInstance.post(`/pos-report/bus-detail-report?page=${page}&size=${size ?? perPage}`,
          // {
          //       "bus":plateNumber.value,
          //       "organization_id":new UserInfo().ORG_ID,
          //       "start_date":startDate.value+" 00:00:00",
          //       "end_date":endDate.value+" 23:59:59"
          //   }


          {
            "bus": plateNumber.value,
            "form": startDate.value,
            "organization_id": new UserInfo().ORG_ID,
            "route": "",
            "to": endDate.value
          }

        )
          .then(res => {
            // set number of pages 
            setPages(res.data.data.totalPages)
            // set total element
            setTotalElements(res.data.data.totalElements)

            var objs = res.data.data.content;
            handleAll(objs);
            setReportLoad(false);

            const currTotals = [];

            objs.forEach((obj) => {
              if (currTotals[obj.currency]) {
                currTotals[obj.currency].total_tickets += obj.total_tickets;
                currTotals[obj.currency].total_amount += obj.total_amount;
              } else {
                currTotals[obj.currency] = {
                  total_tickets: obj.total_tickets,
                  total_amount: obj.total_amount,
                };
              }
            }
            );

            setTotalsByCurrencies(currTotals);
          })
          .catch(err => {

          });

      }

    } else if (plateNumber.value == "") {

      //  all buses 

      setReports([]);
      if (startDate.value == endDate.value) {

        // day all buses 

        setReportTitle("All Buses , Date: " + startDate.value);
        setReportLoad(true);
        setAmounts([]);
        setLabels([]);
        setRevenue([]);
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
        filterInstance.post(`/pos-report/bus-detail-report?page=${page}&size=${size ?? perPage}`,
          // {
          //       "day":startDate.value,
          //       "organization_id":new UserInfo().ORG_ID
          //   }


          {
            "bus": "",
            "form": startDate.value,
            "organization_id": new UserInfo().ORG_ID,
            "route": "",
            "to": startDate.value
          }


        )
          .then(res => {
            // set number of pages 
            setPages(res.data.data.totalPages)

            // set total element
            setTotalElements(res.data.data.totalElements)

            var objs = res.data.data.content;
            handleAll(objs);
            setReportLoad(false);

            const currTotals = [];

            objs.forEach((obj) => {
              if (currTotals[obj.currency]) {
                currTotals[obj.currency].total_tickets += obj.total_tickets;
                currTotals[obj.currency].total_amount += obj.total_amount;
              } else {
                currTotals[obj.currency] = {
                  total_tickets: obj.total_tickets,
                  total_amount: obj.total_amount,
                };
              }
            }
            );

            setTotalsByCurrencies(currTotals);
          })
          .catch(err => {

          });
      } else if (startDate.value > endDate.value || startDate.value < endDate.value) {

        // duration all buses 

        setReportTitle("All buses, Start date: " + startDate.value + " - End date: " + endDate.value);
        setReportLoad(true);
        setAmounts([]);
        setLabels([]);
        setRevenue([]);
        setReportTitle("All buses  From: " + startDate.value + " To: " + endDate.value);
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
        filterInstance.post(`/pos-report/bus-detail-report?page=${page}&size=${size ?? perPage}`,

          // {
          //       "organization_id":new UserInfo().ORG_ID,
          //       "start_date":startDate.value+" 00:00:00",
          //       "end_date":endDate.value+" 23:59:59"
          //   }


          {
            "bus": "",
            "form": startDate.value,
            "organization_id": new UserInfo().ORG_ID,
            "route": "",
            "to": endDate.value
          }

        )
          .then(res => {
            // set number of pages 
            setPages(res.data.data.totalPages)

            // set total element
            setTotalElements(res.data.data.totalElements)

            var objs = res.data.data.content;
            handleAll(objs);
            setReportLoad(false);

            const currTotals = [];

            objs.forEach((obj) => {
              if (currTotals[obj.currency]) {
                currTotals[obj.currency].total_tickets += obj.total_tickets;
                currTotals[obj.currency].total_amount += obj.total_amount;
              } else {
                currTotals[obj.currency] = {
                  total_tickets: obj.total_tickets,
                  total_amount: obj.total_amount,
                };
              }
            }
            );

            setTotalsByCurrencies(currTotals);
          })
          .catch(err => {

          });

      }


    }
  }



  const handleAll = (objs) => {



    /////////////////////////////////////uuuuuuuuuu////////////////////////////////////

    if (objs.length == 0) {
      setReportsMessage("No BUS report available today");
      setFilterDialog(false);
      setReportLoad(false);
    } else {


      var performance = [];
      var lebals = [];

      var total = objs.reduce((a, b) => {
        return a + parseInt(b.total_amount);
      }, 0);

      var tickets = objs.reduce((a, b) => {
        return a + parseInt(b.total_tickets);
      }, 0);


      setTotalAmount(total);
      setTotalTickets(tickets);


      let unique_percentage = [];
      let unique_revenue = [];
      let unique_bus = [];



      // group by plate number 


      var firstPage = [];

      var groupByPlate = groupBy(objs, function (item) {
        return [item.plate_nbr, item.currency];
      });




      groupByPlate.map((o) => {
        var buses = o;
        var plate = buses[0]['plate_nbr'];
        var currency = buses[0]['currency'];
        var total_amount = buses.reduce(function (sum, amount) {
          return sum + parseInt(amount.total_amount);
        }, 0);

        var total_tickets = buses.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.total_tickets);
        }, 0);

        var luggage_tickets = buses.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.luggage_tickets);
        }, 0);

        var passanger_tickets = buses.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.passanger_tickets);
        }, 0);

        var luggage_amount = buses.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.luggage_amount);
        }, 0);

        var passanger_amount = buses.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.passanger_amount);
        }, 0);

        var obj = { "plate_nbr": plate, "total_tickets": total_tickets, "amount": formatMoney(total_amount, 0) + " " + currency, "luggage_tickets": luggage_tickets, "passanger_tickets": passanger_tickets, "luggage_amount": formatMoney(luggage_amount, 0) + " " + currency, "passanger_amount": formatMoney(passanger_amount, 0) + " " + currency };

        // set values for chart 

        performance.push(total_amount);
        lebals.push(plate);

        // set values for pie chart 

        unique_revenue.push(total_amount);
        unique_percentage.push(total_tickets);

        // set unique bus

        unique_bus.push(plate);

        firstPage.push(obj);

      });

      setAmounts(unique_percentage);
      setLabels(unique_bus);
      setRevenue(unique_revenue);

      setReports(firstPage);
      setFilterDialog(false);
      setReportLoad(false);

      // group by plate , departure and route 

      var groupBySchedule = [];

      var groupByPlateDeparture = groupBy(objs, function (item) {
        return [item.plate_nbr, item.departure_time, item.route, item.currency];
      });

      groupByPlateDeparture.map((o, i) => {
        var buses = o;
        var currency = buses[0]['currency'];
        var total_amount = buses.reduce(function (sum, amount) {
          return sum + parseInt(amount.total_amount);
        }, 0);
        var total_tickets = buses.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.total_tickets);
        }, 0);


        var obj = { id: i + 1, currency: currency, departure_time: buses[0]['departure_time'], plate_nbr: buses[0]['plate_nbr'], route: buses[0]['route'], total_amount: total_amount, total_tickets: total_tickets };
        groupBySchedule.push(obj);

      });


      setGroupedBySchedule(groupBySchedule);




    }
  }




  // details report table

  const [detailsMessage, setDetailsMessage] = useState("Loading...");

  const columns1 = [
    {
      name: "id",
      label: "Route",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          var obj = detailsReport.find((o) => o['id'] == value);
          var currency = obj['currency'];
          return (
            <Button color="primary" onClick={() => {
              setManifestoDialog(true);
              setManifestoDetails([]);
              setBusDetails(obj);
              get_details_passenger(obj, currency);
            }}>{obj['route']}</Button>
          );
        }
      }
    },
    {
      name: "departure_time",
      label: "Departure Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography>{format(new Date(value), ["yyyy-MM-dd"])}</Typography>
          );
        }
      }
    },
    {
      name: "departure_time",
      label: "Departure Time",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography>{format(new Date(value), ["HH:mm"])}</Typography>
          );
        }
      }
    },
    // {
    //   name: "plate_nbr",
    //   label: "Bus",
    //   options: {
    //    filter: true,
    //    sort: true,
    //   }
    //  }
    // ,

    // {
    //  name: "source",
    //  label: "Source",
    //  options: {
    //   filter: true,
    //   sort: true,
    //  }
    // },
    // {
    //  name: "destination",
    //  label: "Destination",
    //  options: {
    //   filter: true,
    //   sort: true,
    //  }
    // },
    {
      name: "total_tickets",
      label: "Total tickets",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "total_amount",
      label: "Total Amount",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "currency",
      label: "Currency",
      options: {
        filter: true,
        sort: true,
        display: true
      }
    }
    //  ,
    //  {
    //   name: "departure_time",
    //   label: "Departure Time",
    //   options: {
    //    filter: true,
    //    sort: true,
    //    display:false
    //   }
    //  }
  ];


  const options1 = {
    textLabels: {
      body: {
        noMatch: detailsMessage
      },
    },
    filterType: 'checkbox',
    download: true,
    responsive: "standard",
    selectableRows: false,
    rowsPerPage: 100,
    elevation: 0,
  };





  // daily bus detailed report dialog



  const [bus, setBus] = useState("");


  const [detailsDialog, setDetailsDialog] = useState(false);
  const [detailsLoad, setDetailsLoad] = useState(false);
  const [detailsReport, setDetailsReport] = useState([]);


  const get_daily_details = (bus, currency) => {
    setDetailsDialog(true);
    setDetailsLoad(true);
    setDetailsReport([]);

    console.log("groupedBySchedule");

    // filter by currency

    var filter = groupedBySchedule.filter(o => o.plate_nbr == bus && o.currency == currency);


    setDetailsReport(filter);


    setDetailsLoad(false);



    //   axios.defaults.baseURL = new ReportingService().BASE_URL;
    //   const detailsInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
    //   detailsInstance.post('/pos-report/bus-detail-report',{
    //     "bus":bus,
    //     "organization_id":new UserInfo().ORG_ID,
    //     "start_date":startDate.value,
    //     "end_date":endDate.value
    // }
    // )
    //   .then(res=>{
    //     var objs=res.data.data;
    //     if(objs.length==0){
    //       setDetailsMessage("No report available");
    //     }else{
    //       objs.map((o,i)=>{
    //         o['amount']=formatMoney(parseInt(o['total_amount']),0)+" "+o['currency'];
    //         o['departure_time']=format(new Date(o['departure_time']), ["yyyy-MM-dd HH:mm"]);
    //         o['id']=i+1;
    //       });
    //       console.log(objs);
    //       setDetailsReport(objs);
    //       setDetailsLoad(false);
    //     }

    //   })
    //   .catch(err=>{
    //     setDetailsLoad(false);
    //   }); 
  }

  // manifesto details passenger

  const columns2 = [

    {
      name: "ticket_id",
      label: "Ticket Number",
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: "route",
      label: "Route",
      options: {
        filter: true,
        sort: true
      }
    }
    ,
    {
      name: "client_name",
      label: "Passenger",
      options: {
        filter: true,
        sort: true,
      }
    }
    ,
    {
      name: "source",
      label: "Source",
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "destination",
      label: "Destination",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "price",
      label: "Price",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "currency",
      label: "Currency",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "departure_time",
      label: "Departure Time",
      options: {
        filter: true,
        sort: true,
      }
    }
  ];


  const options2 = {
    textLabels: {
      body: {
        noMatch: reportsMessage
      },
    },
    filterType: 'checkbox',
    download: true,
    responsive: "standard",
    selectableRows: false,
    rowsPerPage: 100,
    elevation: 0,
  };



  // get manifetso as detailed report 

  const [manifestoDialog, setManifestoDialog] = useState(false);

  const [busDetails, setBusDetails] = useState({});

  const [manifestoLoad, setManifestoLoad] = useState(false);

  const [manifestoDetails, setManifestoDetails] = useState([]);


  const get_details_passenger = (b, currency) => {
    setManifestoLoad(true);
    axios.defaults.baseURL = new ReportingService().BASE_URL;
    const passengerInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
    passengerInstance.post('/traffic-report/manifesto-report', {
      "plate_number": b['plate_nbr'],
      "organization_id": new UserInfo().ORG_ID,
      "departure_time": format(new Date(b['departure_time']), ["yyyy-MM-dd HH:mm"]),
      "route": b['route'],
      "currency": b['currency']
    })
      .then(res => {
        var objs = res.data.data;

        // filter by currency
        if (currency) {
          objs = objs.filter(o => o.currency == currency);
        }

        objs.map((o) => {
          o['price'] = formatMoney(parseInt(o['price']), 0);
        });
        setManifestoDetails(objs);
        setManifestoLoad(false);
      })
      .catch(err => {
        setManifestoLoad(false);
      });

  }



  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>
        <Box display='flex'>
          <Box
            display='flex'
            alignItems='center'
            mt={2}
            className={classes.formTitle}
          >
            <Box mr={1}>
              <ConfirmationNumber fontSize='large' color='primary' />
            </Box>{' '}
            <Typography variant='h5' color='default'>
              <b>Bus Report</b>
            </Typography>
          </Box>

          <Button
            color='primary'
            variant='outlined'
            startIcon={<FilterList />}
            onClick={() => {
              setPlateNumber({ value: '', error: '' });
              setFilterDialog(true);
            }}
          >
            Filter
          </Button>
        </Box>

        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Paper className={classes.paper1} elevation={0}>
                <Grid container>
                  <Grid item xs={12} md={12}>
                    <Box display='flex' justifyContent='center'>
                      <Typography variant='h6'>{reportTitle}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Chart
                      options={revenue_bus.options}
                      series={revenue_bus.options.series}
                      type='bar'
                      height='300px'
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            <Grid item md={8} lg={8} sm={12} xs={12}>
              {reportLoad && <LinearProgress />}
              <MUIDataTable
                title={reportTitle}
                data={reports}
                columns={columns}
                options={options}
              />
            </Grid>
            <Grid item md={4} lg={4} sm={12} xs={12}>
              {reportLoad ? (
                <Paper className={classes.paper} elevation={0}>
                  <Grid container>
                    <Grid item xs={12} md={12}>
                      <Box>
                        <Typography variant='h6' className={classes.title}>
                          Bus Performance
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Grid item lg={12} sm={12} xs={12} md={12}>
                        <Box>
                          <Box display='flex' justifyContent='center'>
                            <Skeleton
                              animation='wave'
                              variant='circle'
                              width={200}
                              height={200}
                            />
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              ) : (
                <Paper className={classes.paper} elevation={0}>
                  <Grid container>
                    <Grid item xs={12} md={12}>
                      <Box>
                        <Typography variant='h6' className={classes.title}>
                          Bus Performance
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Grid item md={12} lg={12} xs={6} md={8}>
                        <Chart
                          options={bus_performance.options}
                          series={amounts}
                          type='pie'
                          width={'100%'}
                          height={'100%'}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      {Object.entries(totalsByCurrencies).map(
                        ([currency, totals]) => (
                          <>
                            <Grid item md={6} xs={12}>
                              <Grid container>
                                <Grid item xs={12}>
                                  <Typography>
                                    Total Tickets ({currency})
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant='h5'>
                                    {totals.total_tickets}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <Grid container>
                                <Grid item xs={12}>
                                  <Typography>
                                    Total Amount ({currency})
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant='h5'>
                                    {formatMoney(totals.total_amount, 0) +
                                      ' ' +
                                      currency}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        )
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              )}
            </Grid>
          </Grid>
        </Box>
      </div>

      {/* filter dialog  */}

      <Dialog
        maxWidth='sm'
        fullWidth
        open={filterDialog}
        onClose={() => {
          setFilterDialog(true);
        }}
        aria-labelledby='filter'
        aria-describedby='filter'
      >
        <DialogTitle id='filter'>{'Filter'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box>
              <Box mt={1}>
                <Autocomplete
                  size='small'
                  options={buses}
                  getOptionLabel={(option) => option.vehicle.plate_number}
                  fullWidth
                  onChange={(event, newValue) => {
                    if (newValue != null) {
                      setPlateNumber({
                        value: newValue.vehicle.plate_number,
                        error: '',
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Select Bus'
                      variant='outlined'
                    />
                  )}
                />
              </Box>

              <Box mt={1}>
                <DatePicker
                  fullWidth
                  disableToolbar
                  variant='inline'
                  format='yyyy-MM-dd'
                  margin='dense'
                  autoOk
                  label='Start date'
                  value={startDate.value}
                  inputVariant='outlined'
                  onChange={(v) => {
                    console.log('choosen1: ', Format(v, ['yyyy-MM-dd']));

                    setStartDate({
                      value: Format(v, ['yyyy-MM-dd']),
                      error: '',
                    });
                  }}
                  InputProps={{
                    disableUnderline: true,
                    style: { paddingRight: 0 },
                  }}
                />
              </Box>
              <Box mt={1}>
                <DatePicker
                  fullWidth
                  disableToolbar
                  variant='inline'
                  format='yyyy-MM-dd'
                  margin='dense'
                  autoOk
                  label='End date'
                  value={endDate.value}
                  inputVariant='outlined'
                  onChange={(v) => {
                    console.log('choosen2: ', v);
                    setEndDate({ value: Format(v, ['yyyy-MM-dd']), error: '' });
                  }}
                  InputProps={{
                    disableUnderline: true,
                    style: { paddingRight: 0 },
                  }}
                />
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setFilterDialog(false);
            }}
            color='secondary'
            className={classes.btn}
          >
            <Typography>Close</Typography>
          </Button>

          <Button
            disabled={reportLoad}
            onClick={() => {
              setIsFiltering(true);
              filter_report(0);
            }}
            color='primary'
            variant='contained'
            className={classes.btn}
          >
            {reportLoad ? (
              <CircularProgress size={25} color='secondary' />
            ) : (
              <Typography>View</Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* daily bus detailed report  */}

      <Dialog
        fullScreen
        open={detailsDialog}
        style={{ marginTop: '80px' }}
        onClose={() => { }}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={() => {
                setDetailsDialog(false);
              }}
              aria-label='close'
            >
              <Close />
            </IconButton>
            <Typography variant='h6' className={classes.title}>
              Tickets
            </Typography>

            <Button
              autoFocus
              color='inherit'
              onClick={() => {
                setDetailsDialog(false);
              }}
            >
              Close
            </Button>
          </Toolbar>
        </AppBar>

        <Box mt={2}>
          {detailsLoad && <LinearProgress />}
          <MUIDataTable
            title={'Plate Number >' + bus}
            data={detailsReport}
            columns={columns1}
            options={options1}
          />
        </Box>
      </Dialog>

      {/* manifesto details report */}

      <Dialog
        fullScreen
        open={manifestoDialog}
        style={{ marginTop: '80px' }}
        onClose={() => {
          setManifestoDialog(false);
        }}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={() => {
                setManifestoDialog(false);
              }}
              aria-label='close'
            >
              <Close />
            </IconButton>
            <Typography variant='h6' className={classes.title}>
              Passenger Tickets
            </Typography>

            <Button
              autoFocus
              color='inherit'
              onClick={() => {
                setManifestoDialog(false);
              }}
            >
              Close
            </Button>
          </Toolbar>
        </AppBar>

        <Box mt={2}>
          {manifestoLoad && <LinearProgress />}
          <MUIDataTable
            title={
              busDetails['route'] +
              ' | ' +
              busDetails['departure_time'] +
              ' | ' +
              busDetails['plate_nbr']
            }
            data={manifestoDetails}
            columns={columns2}
            options={options2}
          />
        </Box>
      </Dialog>
    </MuiPickersUtilsProvider>
  );
}

export default withLocalize(ReportPOS);